import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Flex, Row, Space, Switch, Button, Tag } from "antd";
import { useTranslation } from "react-i18next";
import TableAntd from "components/elements/Table/Table";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import styles from "../styles/NotificationList.module.css";

const NotificationList = ({
    notificationList = [],
    isLoading = false,
    pagination = {},
    onChange = () => { },
    onCreate = () => { },
    onEdit = () => { },
    onDelete = () => { },
    onStatus = () => { },
}) => {
    const { t } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t("common.index")}</div>,
            key: "id",
            width: "6%",
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: <div className="text-table">{t("notification.label.name")}</div>,
            dataIndex: "templateName",
            key: "templateName",
            width: "18%",
            // render: (v) => <b>{v}</b>,
        },
        {
            title: <div className="text-table">{t("notification.label.event")}</div>,
            dataIndex: "emailTemplateCode",
            key: "emailTemplateCode",
            width: "16%",
        },
        {
            title: <div className="text-table">{t("notification.label.recipient")}</div>,
            key: "recipient",
            width: "20%",
            render: (_, record) => (
                <Space direction="vertical" size={2}>
                    {record.toList?.length > 0 && (
                        <div>To: {record.toList.map((r) => <Tag key={r.value}>{r.label || r.value}</Tag>)}
                        </div>
                    )}
                    {record.ccList?.length > 0 && (
                        <div>CC: {record.ccList.map((r) => <Tag key={r.value}>{r.label || r.value}</Tag>)}</div>
                    )}
                </Space>
            ),
        },
        {
            title: <div className="text-table">{t("notification.label.channel")}</div>,
            key: "channel",
            width: "10%",
            render: (_, record) => (
                <Space>
                    {record.isEmail && <Tag color="blue">{t("notification.channel.email")}</Tag>}
                    {record.isMobile && <Tag color="green">{t("notification.channel.mobile")}</Tag>}
                </Space>
            ),
        },
        {
            title: <div className="text-table">{t("year_accumulate_list.label.status")}</div>,
            dataIndex: "isActive",
            key: "isActive",
            align: "center",
            width: "10%",
            render: (v, record) => (
                <Switch checked={v === "Y"} onChange={(checked) => onStatus(checked, record)} />
            ),
        },
        {
            title: <div className="text-table">{t("action.action")}</div>,
            key: "action",
            width: "8%",
            align: "center",
            fixed: "right",
            render: (_, record) => (
                <Dropdown
                    menu={{
                        items: [
                            { key: "edit", onClick: () => onEdit(record), label: t("action.edit"), icon: <EditOutlined style={{ fontSize: 18, color: "gray" }} /> },
                            { key: "delete", onClick: () => onDelete(record), label: t("action.delete"), icon: <DeleteOutlined style={{ fontSize: 18, color: "gray" }} /> },
                        ],
                    }}
                >
                    <MoreOutlined style={{ fontSize: 25, color: "gray", cursor: "pointer" }} />
                </Dropdown>
            ),
        },
    ];

    return (
        <Space className={styles.container} direction="vertical" size={24}>
            <Row justify="end">
                <Button
                    onClick={onCreate}
                    style={{ width: "max-content", height: 44, borderRadius: 8, backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                    type="primary"
                >
                    <Flex align="center" justify="center" gap={8}>
                        <CreateIcon />
                        <span>{t("notification.create")}</span>
                    </Flex>
                </Button>
            </Row>
            <TableAntd
                columns={columns}
                dataSource={notificationList}
                loading={isLoading}
                pagination={pagination}
                onChange={onChange}
                rowKey="id"
            />
        </Space>
    );
};

export default NotificationList;